const HEADERS = { 'Content-Type': 'application/json' };

type validateTransactionBody = {
    confirmationKey: string | null;
    userKey: string | null;
    totalInCents: string | null;
};

export async function validateTransaction(jsonData: validateTransactionBody) {
    const body = JSON.stringify(jsonData);
    const validateRes = await fetch('/validate-transaction', { method: 'POST', headers: HEADERS, body });
    const validateData = await validateRes.json();
    return validateData;
}

export const checkTokenAndApprovedDeal = async (
    transactionId: string,
    /** The terminal the charge settled on. Pelecard scopes a transaction to its
     *  terminal, so verifying with a different one finds nothing. */
    paymentsTerminalId?: string | number | null
) => {
    try {
        const body = JSON.stringify({ transactionId, paymentsTerminalId: paymentsTerminalId || undefined });
        const response = await fetch(`/payment-get-transaction`, { method: 'POST', headers: HEADERS, body });
        const dealDetails = await response.json();
        return dealDetails;
    } catch (error) {
        console.error('ERROR - error while tying check deal approved ', error);
    }
};

/** Same request as `checkTokenAndApprovedDeal`, but THROWS on a network failure
 *  or a non-2xx response instead of swallowing it — used by the inline poll
 *  loops (CreditCardSubForm / PreReceiptModalLevel2) so they can tell "our own
 *  backend couldn't answer" (container restart, Pelecard's gateway briefly
 *  unreachable, terminal misconfig — OUR problem, never a signal that the
 *  charge itself failed) apart from "Pelecard genuinely says not resolved yet"
 *  (a real answer, safe to count toward a give-up cap). Conflating the two used
 *  to mean a transient server hiccup during the poll window could make an
 *  inline flow give up and abandon issuing the receipt for a charge that may
 *  well have succeeded. */
export const fetchTransactionStatus = async (
    transactionId: string,
    paymentsTerminalId?: string | number | null
) => {
    const body = JSON.stringify({ transactionId, paymentsTerminalId: paymentsTerminalId || undefined });
    const response = await fetch(`/payment-get-transaction`, { method: 'POST', headers: HEADERS, body });
    if (!response.ok) {
        throw new Error(`/payment-get-transaction responded ${response.status}`);
    }
    return response.json();
};
export const getVoucherDetails = async (redisId: string) => {
    try {
        const body = JSON.stringify({ id: redisId });
        const response = await fetch(`/get-redis-object`, { method: 'POST', headers: HEADERS, body: body });
        const voucherDetails = await response.json();
        return voucherDetails;
    } catch (err) {
        console.error(err);
        return null;
    }
};
